import styled from 'styled-components';
import * as React from 'react';

export const TextContainerStyle = styled.div`
  font-weight: lighter;
  max-width: 65em;
  padding: -1px 5em 0em 0;
  margin-top: 0em;

  &.center {
    p {
      text-align: center;
    }
  }

  p {
    text-align: center;
    padding: 0;
    width: 100%;
    max-width: 65em;
    margin: 1em 0em 0em 0em;

    :last-child {
      margin-bottom: 1em;
    }
  }

  @media all and (max-width: 450px) {
    p {
      :last-child {
        margin-bottom: 2em;
      }
    }
  }

  h4 {
    color: ${({ theme }) => theme.colors.primary};
  }

  .text {
    text-align: left;
  }

  @media all and (min-width: 375px) and (max-width: 1100px) {
    padding: 1em 1.4em 1em !important;
    margin-top: -1em;
  }
`;

export const SectionTextContainer: React.FC<{
  text?: string;
  style?: any;
  className?: any;
}> = ({ text, style, className }) => {
  return text ? <TextContainerStyle className={className} dangerouslySetInnerHTML={{ __html: text }} style={style} /> : null;
};
